import type { App } from 'vue';
import './dayjs';
import InitEchart from './e-charts';
import './monaco';

export function Init(app: App) {
  InitEchart(app);
}
